import styled from "styled-components";

export const BackButtonStyle = {
  height: "40px",
  width: "40px",
  backgroundColor: "white",
  boxShadow: "0px 4px 9px 0px rgba(16, 47, 67, 0.12)",
};

export const BackButtonRow = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  font-size: 18px;
  font-weight: 400;
  line-height: 150%;
`;

export const ButtonRow = styled.div`
  display: flex;
  gap: 16px;
`;
